import { createSelector } from 'reselect';
import { studyOlympiadsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const studyOlympiadsYearsSelector = createSelector(studyOlympiadsSelector, (olimpiads) =>
  extractDatesFromNestedItems(
    [olimpiads],
    [
      {
        type: 'range',
        startField: 'startDate',

        endField: 'endDate',
      },
    ],
  ),
);
